import { ILogger } from "../cityversetycoon/logger/ILogger";
import { BaseAnalyticEvent } from "./events/BaseAnalyticEvent";
import { IAnalyticsProvider } from "./IAnalyticsProvider";

export class FacebookAnalyticsProvider implements IAnalyticsProvider {
    private readonly logger: ILogger;

    public constructor(logger: ILogger) {
        this.logger = logger;
    }

    public registerEvent(baseEvent: BaseAnalyticEvent): void {
        try {
            (window as any).fbq('track', baseEvent.eventType, {}, { eventID: baseEvent.eventId });
            this.logger.info(`Facebook event: ${baseEvent.eventType}`);
        } catch (error) {
            throw new Error(error);
        }
    }
}
